angular.module('core')
    .controller('ChooseSchoolModalController', [
        '$scope', '$rootScope', 'teacherApi', 'settingsApi', 'teacher', '$window', 
    function(
        $scope, $rootScope, $teacherApi, $settingsApi, $teacher, $window
    ) {

        //do not change
        var MODE_SCHOOL_ADMIN = 1;
        var MODE_CLASSROOMS = 2;

        //ok, you can change
        $scope.DROPDOWN_USE_THRESHOLD = 10; //when there are this many schools or more, use a select instead of links

        $scope.schools = {selected:{name: "Select a school to view..."}, list:[]};
        var schoolIds = $teacher.school_admin_ids;
        var schoolNames = $teacher.school_names;
        var classroomIds = $teacher.classroom_ids;
        schoolIds.forEach(function(id) {
            $scope.schools.list.push({ id: id, name: schoolNames[id] });
        });

        $scope.hasClassrooms = Boolean(classroomIds && classroomIds.length);

        $scope.modalClose = function() {
            $rootScope.$broadcast('modalClose');
        };


        $scope.handleSchoolSelection = function(school) {
            $teacherApi.saveTeacherSessionSettings({
                mode: MODE_SCHOOL_ADMIN,
                selected_school_id: school.id,
                selected_school_name: school.name
            }, function() {
                $window.location.href='/';
            });
        };

        $scope.handleViewClassroomsClick = function() {
            $teacherApi.saveTeacherSessionSettings({
                mode: MODE_CLASSROOMS
            }, function() {
                $window.location.href='/';
            });
        };

    }]);
